/** Cấu hình runtime của admin từ Vite env (VITE_*). Fail fast nếu thiếu API base URL. */
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

if (!apiBaseUrl) {
  throw new Error("[admin] thiếu VITE_API_BASE_URL — đặt trong .env (vd http://localhost:3000/v1)");
}

export const env = {
  apiBaseUrl,
} as const;
